module.exports = {"seopress_titles_sep":{"type":"input","name":"Separator"},"seopress_titles_home_site_title":{"type":"input","name":"Site title"},"seopress_titles_home_site_desc":{"type":"input","name":"Meta description"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Manager/Site/Plugins/seopress.json
// module id = pi+J
// module chunks = 17